(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-header"]) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('.aw-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const close = () => { menu.open = false; menu.querySelector('summary').focus(); };
      menu.querySelector('.aw-menu__close').addEventListener('click', close);
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
